export default function getWebsiteFavicon(url) {
  return `https://www.google.com/s2/favicons?domain_url=${new URL(url).hostname}`
}
